// extracted by mini-css-extract-plugin
export var dividerLine = "_6x-3";
export var itemImage = "_6x-9";
export var lightDivider = "_6x-4";
export var modalContent = "_6x-5";
export var modalContentCompact = "_6x-6";
export var productCard = "_6x-a";
export var productImage = "_6x-b";
export var productImageCompact = "_6x-7";
export var productImagePlaceholder = "_6x-c";
export var productImagePlaceholderCompact = "_6x-8";
export var progressBarBackground = "_6x-1";
export var progressBarContainer = "_6x-0";
export var progressBarFill = "_6x-2";